
import { reactive, toRefs, watchEffect, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
// import { RouteMeta } from "@/common/Types/index";

export default {
  name: "",
  props: {
    meteItems: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    // const data = reactive<RouteMeta>({
    //   routeMetes: [],
    //   title: "",
    // });
    const jumpRouter = (type: any) => {
      let str = "";
      if (type === "我发起的") {
        str = "signlaunch";
      } else if (type === "抄送我的") {
        str = "signcopy";
      } else if (type === "已审批") {
        str = "signconting";
      } else if (type === "申请列表") {
        str = "openlist";
      } else if (type === "工商变更") {
        str = "changelist";
      } else {
        str = "signsure";
      }
      router.push({
        name: str,
      });
    };
    // watchEffect(() => {
    //   data.routeMetes = route.meta.title as string[];
    // });
    return {
      jumpRouter,
    };
  },
};
